import React, { useState, useEffect } from 'react';

const items = [
  { 
    title: "Video Game", 
    image: "/img/lms/Videogame.png",
    desc: "Materi pembelajaran dalam bentuk game interaktif seperti puzzle dan simulasi berbasis cerita." 
  },
  { 
    title: "Absensi", 
    image: "/img/lms/Absensi.png",
    desc: "Dicatat otomatis saat akses kelas/tugas, menjadi indikator kedisiplinan siswa." 
  },
  { 
    title: "Kalender", 
    image: "/img/lms/Kalender.png",
    desc: "Sync otomatis jadwal kelas, ujian, tugas, dan deadline dengan pengingat pribadi." 
  },
  { 
    title: "Bank Soal", 
    image: "/img/lms/Banksoal.png",
    desc: "Kumpulan soal terstruktur berdasarkan topik dan tingkat kesulitan untuk latihan mandiri." 
  },
  { 
    title: "Perpustakaan", 
    image: "/img/lms/Perpustakaan.png",
    desc: "Koleksi e-book, video, dan referensi tambahan untuk pendalaman materi." 
  },
  { 
    title: "Pengumuman", 
    image: "/img/lms/Pengumuman.png",
    desc: "Informasi penting seputar tugas, perubahan jadwal, dan pengingat lainnya." 
  },
  { 
    title: "Kuis atau ujian", 
    image: "/img/lms/Kuis atau ujian.png",
    desc: "Kuis harian dan ujian semester dengan berbagai tipe soal (PG, esai, dll)." 
  },
  { 
    title: "Kategori Kurikulum", 
    image: "/img/lms/KategoriKurikulum.png",
    desc: "Materi pembelajaran tersusun rapi berdasarkan mata pelajaran dan topik." 
  },
  { 
    title: "Laporan perkembangan murid", 
    image: "/img/lms/Laporanmurid.png",
    desc: "Laporan detail perkembangan akademik siswa meliputi nilai, kehadiran, dan penyelesaian tugas." 
  },
  { 
    title: "Penilaian dan komentar hasil pekerjaan", 
    image: "/img/lms/Penilaian.png",
    desc: "Sistem penilaian otomatis dengan feedback untuk evaluasi siswa." 
  },
  { 
    title: "Isi materi (Video, dokumen, teks, dan suara)", 
    image: "/img/lms/Isimateri.png",
    desc: "Materi belajar dalam berbagai format untuk semua gaya belajar." 
  },
  { 
    title: "Forum Diskusi", 
    image: "/img/lms/ForumDiskusi.png",
    desc: "Ruang diskusi antara guru-siswa untuk tanya jawab materi/tugas." 
  },
  { 
    title: "Progress Tracker", 
    image: "/img/lms/ProgressTracker.png",
    desc: "Visualisasi perkembangan belajar siswa dalam bentuk checklist dan progress bar." 
  },
  { 
    title: "Analitik Pembelajaran", 
    image: "/img/lms/AnalitikPembelajaran.png",
    desc: "Analisis data aktivitas siswa (waktu belajar, skor, kehadiran, dll)." 
  },
];

const columnSize = 2;

const LmsCarousel: React.FC = () => {
  const [visibleItems, setVisibleItems] = useState(8);
  const [startIndex, setStartIndex] = useState(0);
  const [hoveredItem, setHoveredItem] = useState<number | null>(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setVisibleItems(4);
      } else {
        setVisibleItems(8);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNext = () => {
    const maxStart = Math.ceil(items.length / columnSize) * columnSize - visibleItems;
    if (startIndex < maxStart) {
      setStartIndex(prev => Math.min(prev + columnSize, maxStart));
    }
  };

  const handlePrev = () => {
    setStartIndex(prev => Math.max(prev - columnSize, 0));
  };

  const currentItems = items.slice(startIndex, startIndex + visibleItems);

  const columns: { title: string; image: string; desc: string }[][] = [];
  for (let i = 0; i < currentItems.length; i += columnSize) {
    columns.push(currentItems.slice(i, i + columnSize));
  }

  return (
    <div className="relative w-full max-w-6xl mx-auto">
      {/* Prev Button */}
      {startIndex > 0 && (
        <button
          onClick={handlePrev}
          className="absolute w-10 h-10 left-0 top-1/2 -translate-y-1/2 z-10 shadow p-2 rounded-full flex items-center justify-center -mt-4"
        >
          <img
            src="/img/lms/left-arrow.png"
            alt="Left"
            className="absolute inset-0 m-auto"
          />
        </button>
      )}
  
      {/* Carousel Items */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 px-4 py-6 -mb-4 transition-all duration-300 -mt-4">
        {columns.map((column, columnIndex) => (
          <div key={columnIndex} className="flex flex-col gap-4">
            {column.map((item, itemIndex) => {
              const absoluteIndex = startIndex + columnIndex * columnSize + itemIndex;
              return (
                <div 
                  key={`${startIndex}-${columnIndex}-${itemIndex}`} 
                  className="bg-white rounded-lg overflow-hidden shadow-md relative"
                  onMouseEnter={() => setHoveredItem(absoluteIndex)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <div className="relative">
                    <img src={item.image} alt={item.title} className="h-40 w-full object-cover" />
                    <div className="absolute bottom-0 left-0 right-0 bg-opacity-30 py-1">
                      <p className="text-white text-start font-body font-semibold pl-4 pb-2 text-base">{item.title}</p>
                    </div>
                  </div>
                  {/* Hover Description */}
                  {hoveredItem === absoluteIndex && (
                    <div className="absolute inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 transition-opacity duration-300">
                      <p className="text-white text-sm text-center">{item.desc}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* Next Button */}
      {startIndex + visibleItems < items.length && (
        <button
          onClick={handleNext}
          className="absolute w-10 h-10 right-0 top-1/2 -translate-y-1/2  z-10 shadow p-2 rounded-full flex items-center justify-center -mt-4"
        >
          <img
            src="/img/lms/right-arrow.png"
            alt="Right Hover"
            className="absolute inset-0 m-auto"
          />
        </button>
      )}
    </div>
  );
};

export default LmsCarousel;
